// @flow
import { lifecycle, type HOC } from "recompose"

function withOnMount<T>(onMount: T => void): HOC<T, T> {
  return lifecycle({
    componentDidMount() {
      onMount(this.props)
    },
  })
}

export default withOnMount



// WEBPACK FOOTER //
// ./src/hoc/withOnMount.js